// No-op stub for this.$ga so existing event calls don't throw
// after disabling @nuxtjs/google-analytics
// This turns off GA but prevents us from ripping out all of the this.$ga.event() in case we want to use those later.
const noop = () => {};
const ga = { event: noop, page: noop, query: noop, set: noop, enable: noop, disable: noop };

export default (ctx, inject) => {
  inject('ga', ga);
};
